import Dropdown from "stimulus-dropdown";
import {useClickOutside} from "stimulus-use";
import {requestAnimFrame} from "chart.js/helpers";

export default class extends Dropdown {
  static targets = ["list", "toggler"];

  initialize() {
    this.onScroll = this.onScroll.bind(this)
  }

  connect() {
    super.connect();
    this.element[this.identifier] = this;
    useClickOutside(this, {element: this.menuTarget});
    this.element.dispatchEvent(new Event('connected'));
  }

  hide(event) {
    if (event)
      super.hide(event);
    this.element.classList.remove("open");
    this.menuTarget.classList.add("hidden");
    this.element.dispatchEvent(new CustomEvent("close"))
    window.removeEventListener("scroll", this.onScroll, true);
  }

  toggle(event) {
    if (this.menuTarget.classList.contains("hidden")) {
      this.show()
    } else {
      this.hide(event)
    }
  }

  show(event) {
    this.element.classList.add("open");
    this.menuTarget.classList.remove("hidden");
    this.updatePosition();
    window.addEventListener("scroll", this.onScroll, true);
  }


  enable() {
    this.element.classList.remove("disabled");
  }

  disable() {
    this.element.classList.add("disabled");
  }

  onScroll(event) {
    try {
      if (event?.target && event.target.closest('.oq-dropdown')) {
        // Prevent repositioning if scrolling inside dropdown
        return false;
      }
    } catch (e) {
    }
    this.updatePosition()
  }

  isFixedRelativeToContainer(element) {
    // Safari fixed toujours relatif au viewport, on n applique pas d'offset
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
    if (isSafari && isIos) {
      return null;
    }

    let currentNode = element.parentElement;

    while (currentNode && currentNode !== document.documentElement) {
      const computedStyle = window.getComputedStyle(currentNode);
      // Check for properties that create a new containing block
      if (
        computedStyle.transform !== 'none' ||
        computedStyle.willChange.includes('transform') ||
        computedStyle.filter !== 'none' ||
        computedStyle.backdropFilter !== 'none' ||
        computedStyle.perspective !== 'none' ||
        computedStyle.contain !== 'none'
      ) {
        return currentNode; // Return the container that affects positioning
      }

      currentNode = currentNode.parentElement;
    }

    return null; // Returns null if the element is relative to the viewport
  }

  updatePosition() {
    // Only update position when dropdown is open
    if (!this.element.classList.contains("open")) return;

    requestAnimationFrame(() => {
      const container = this.isFixedRelativeToContainer(this.menuTarget)
      const padding = 8;

      // Reset positioning
      this.menuTarget.style.removeProperty('top');
      this.menuTarget.style.removeProperty('right');
      this.menuTarget.style.removeProperty('bottom');
      this.menuTarget.style.removeProperty('left');
      this.menuTarget.style.maxHeight = '';

      const {top, left, right, height} = this.togglerTarget.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      const windowHeight = document.documentElement.scrollHeight;

      let offsetX = 0
      let offsetY = 0
      const parentScrollTop = this.element.scrollTop;
      if (container) {
        const containerRect = container.getBoundingClientRect()
        offsetX = containerRect.left * -1
        offsetY = containerRect.top * -1 - parentScrollTop
      }

      // Start by positioning below the toggler
      let menuTop = top + height + padding + offsetY;
      let menuLeft = left + offsetX;

      this.menuTarget.style.top = `${menuTop}px`;
      this.menuTarget.style.left = `${menuLeft}px`;

      // Recalculate menu rect after setting position
      const menuRect = this.menuTarget.getBoundingClientRect();

      // If dropdown overflows to the right, align it from the right instead
      if (menuRect.right > windowWidth) {
        const menuRight = windowWidth - right + offsetX;
        this.menuTarget.style.removeProperty('left');
        this.menuTarget.style.right = `${menuRight}px`;
      }

      // If dropdown overflows the bottom, try to display it above
      if (menuRect.bottom > windowHeight) {

        const spaceAbove = top - padding + offsetY;
        const fitsAbove = menuRect.height <= spaceAbove;

        if (fitsAbove) {
          const menuAboveTop = top - menuRect.height - padding + offsetY;
          this.menuTarget.style.top = `${menuAboveTop}px`;
        } else {
          // If it doesn't fit, limit max height to what's available above
          this.menuTarget.style.maxHeight = `${spaceAbove}px`;
          const menuAboveTop = top - spaceAbove + offsetY;
          this.menuTarget.style.top = `${menuAboveTop}px`;
        }
      }
    })
  }

  clickOutside(e) {
    e.preventDefault()

    let rect = this.menuTarget.getBoundingClientRect();
    if (!(e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom)) {
      this.hide(e);
    }
  }
}
